import S from './GlobalAlertsConfigurationStyles';
import AlertsConfigItem from '../../../DeviceDetails/Modals/DeviceSettings/AlertsConfigItem/AlertsConfigItem';
import Tabs from '../../../../components/common/Tabs/Tabs';
import { alertEventsMap } from '../../../Alerts/constants/alertEventsMap';

type Props = {
  fleetId: string;
  toggleModal: (closed: boolean) => void;
};

const hideAlerts = ['DevStreamEventAccidentCameraRemoval', 'DevStreamEventCameraBlockage']; // Alerts to hide

function GlobalAlertsConfiguration({ fleetId, toggleModal }: Props): JSX.Element {
  const setTabs = (): any => {
    const tabs = Object.entries(alertEventsMap)
      .filter(([name]) => !hideAlerts.includes(name)) // Exclude hidden alerts
      .map(([name, alert]) => {
        const baseFields = [
          {
            name: 'alertCreate',
            label: 'Enable alert generation',
            text: false,
            defaultValue: true,
            placeholder: 'Check value',
            type: undefined,
          },
        ];

        const extraFields: any[] | undefined = [];

        const fields = baseFields.concat(extraFields);

        const config = (
          <AlertsConfigItem
            key={name}
            name={name}
            global
            deviceId=""
            fleetId={fleetId}
            label={alert.shortDesc}
            toggleModal={toggleModal}
            fields={fields}
          />
        );

        return {
          label: alert.badge,
          id: name,
          content: config, // Return the JSX content directly
        };
      });

    return tabs;
  };

  const tabsContent = setTabs(); // Get the tabs content array

  return (
    <S.Wrapper>
      <Tabs
        tabs={tabsContent} // Pass the actual JSX content here
      />
    </S.Wrapper>
  );
}

export default GlobalAlertsConfiguration;
